import {Component, ElementRef, ViewChild} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {FontAwesomeService} from '@services/font-awesome.service';
import {Store} from '@ngrx/store';
import {AccountService} from '@services/account.service';
import {AppState} from '@store/reducers';
import {Subscription} from 'rxjs/Subscription';
import {ActivatedRoute} from '@angular/router';
import {Subject} from 'rxjs/Subject';
import {takeUntil} from 'rxjs/operators';

@Component({
  selector: 'app-shipment-info',
  templateUrl: './shipment-info.component.html',
  styleUrls: ['./shipment-info.component.scss']
})
export class ShipmentInfoComponent {
  subscription: Subscription;
  id: number;
  additional = false;
  summary = false;
  shipment: any;
  sourceShipments: any[];
  pageSize = 3;
  type: string;
  rows = [
    {label: 'Consignment no', value: 'consignment_no'},
    {label: 'Consignor', value: 'consignor'},
    {label: 'Consignee', value: 'consignee'},
    {label: 'Status', value: 'status'},
    {label: 'Price', value: 'price'},
  ];
  private unsubscribe: Subject<void> = new Subject();
  @ViewChild('search') search: ElementRef;
  constructor(
    private translate: TranslateService,
    public faService: FontAwesomeService,
    private activateRoute: ActivatedRoute,
    private accountService: AccountService,
  ) {}

  ngOnInit() {
    this.activateRoute.params
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((params) => {
        this.id = params['id'];
        this.getShipment(this.id);
    });
    this.activateRoute.data
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(data => this.type = data.route);

  }


  getShipment(id) {
    this.accountService.getShipment(id).subscribe((data) => {
      this.shipment = data.shipments;
      if (this.shipment.extra_charges.length > 0) {
        this.additional = true;
      }
      if (this.shipment.delivery_address !== null) {
        this.summary = true;
      }
    });
  }
  applyFilter(event) {}

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}




// WEBPACK FOOTER //
// ./src/app/modules/shipments/components/shipment-info/shipment-info.component.ts